module.exports = __webpack_public_path__ + "img/selected2-min.618d16b8.png";